import { aiImageGenerationEnabled } from 'reactApp/appHelpers/featuresHelpers/features/aiImageGeneration';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { store as reduxStore } from 'reactApp/store';

/**
 * Можем ли показывать кнопку генерации?
 */
export const getIsCanShowAiPhotoGenerationButton = (storage: EStorageType) => {
    if (!aiImageGenerationEnabled) {
        return false;
    }

    const validStorage =
        storage === EStorageType.home ||
        storage === EStorageType.gallery ||
        storage === EStorageType.favorites ||
        storage === EStorageType.feed;
    const state = reduxStore.getState();
    const isBizUser = UserSelectors.isBizUser(state);
    const isOverQuotaUser = UserQuotaSelectors.isOverquota(state);
    const isQuotaLoaded = UserQuotaSelectors.isQuotaLoaded(state);

    return !isOverQuotaUser && isQuotaLoaded && !isBizUser && !EnvironmentSelectors.isMobile() && validStorage;
};
